import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';   // needed for Router injection in ChatbotComponent

// Components
import { ChatbotComponent }     from './components/chat-window/chatbot.component';
import { ChatWindowComponent }  from './components/chat-window/chat-window.component';
import { ChatSessionsComponent } from './components/chat-sessions/chat-sessions.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';
import { ChatInputComponent }   from './components/chat-input/chat-input.component';
import { ChatTypingComponent }  from './components/typing-indicator/chat-typing.component';

// Pipes
import { ChatMarkdownPipe }   from './pipes/chat-markdown.pipe';
import { XcActiveTitlePipe }  from './pipes/xc-active-title.pipe';

// Directives
import { ChatAutoResizeDirective } from './directives/chat-auto-resize.directive';

// Services
import { ChatApiService }    from './services/chat-api.service';
import { ChatConfigService } from './services/chat-config.service';
import { ChatStateService }  from './store/chat-state.service';

@NgModule({
  declarations: [
    // Components
    ChatbotComponent,
    ChatWindowComponent,
    ChatSessionsComponent,
    ChatMessageComponent,
    ChatInputComponent,
    ChatTypingComponent,
    // Pipes
    ChatMarkdownPipe,
    XcActiveTitlePipe,
    // Directives
    ChatAutoResizeDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule,   // provides Router for injection + routerLink directive
  ],
  providers: [
    ChatApiService,
    ChatConfigService,
    ChatStateService,
  ],
  exports: [
    ChatbotComponent,   // ← the only export you need in AppModule
  ],
})
export class ChatbotModule {}